import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

export const ExchangeRateModal: BaseModalType = (props) => {
  const { close } = props
  const { t } = useTranslation()

  return (
    <Modal>
      <Modal.Header>{t('Wallet.Indicative Rate')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Text>
          {t(
            'Wallet.The current rate is subject to ongoing updates and may not be the same at the time of the conversion'
          )}
        </Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Got It')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
